module.exports = __webpack_public_path__ + "img/nav-profile.5a9f6368.svg";